import { pushDataLayerEvent } from "utils/dataLayer";

/**
 * Previously called react-ga (Universal Analytics), which was never initialized,
 * so these events went nowhere. Now pushed to the dataLayer for GTM to pick up.
 */
const useGAEventsTracker = (category = "Event Category") => {
  const trackEvent = (action = "action", label = "label") => {
    pushDataLayerEvent("ga_event", {
      event_category: category,
      event_action: action,
      event_label: label,
    });
  };
  return trackEvent;
};

export default useGAEventsTracker;
